define.alias("shared/components/shared/post/secondary/caption-writer/loader", "auth/components/shared/post/secondary/caption-writer/loader");